	const readMoreSelectors = {
		wrapper: ".js-read-more-less",
		button: {
			readMore: ".js-read-more",
			readLess: ".js-read-less"
		},
		description: {
			short: ".js-short-description",
			full: ".js-full-description"
		}
	};  

	(function () {
		let readMoreLessWrapper = document.querySelectorAll(readMoreSelectors.wrapper);

		readMoreLessWrapper.forEach(element => {
				
			let readMoreButton = element.querySelector(
				readMoreSelectors.button.readMore
			);
			let readLessButton = element.querySelector(
				readMoreSelectors.button.readLess
			);
			let shortDescription = element.querySelector(
				readMoreSelectors.description.short
			);
			let fullDescription = element.querySelector(
				readMoreSelectors.description.full
			);

			if (!readLessButton || !readMoreButton) {
				return null;
			}

			if (!shortDescription || !fullDescription) {
				return null;
			}

			readMoreButton.addEventListener("click", ()=> {
				shortDescription.classList.add("hidden");
				fullDescription.classList.remove("hidden");
			});

			readLessButton.addEventListener("click", ()=> {
				shortDescription.classList.remove("hidden");
				fullDescription.classList.add("hidden");
			});

		});
		
	})();